// extracted by mini-css-extract-plugin
export default {"wrapper":"kuOVHxJtGWZ5scZaUfY6","content":"vOa4Pn2EemDRv721oVeS","dataRow":"IDmMXFa7Y7dbYT7sqw_W"};